import { connect } from 'react-redux';

import InvestorProfileStart from './InvestorProfileStart';

const mapStateToProps = ({ user: { profile } }) => ({
  username: profile?.data?.name_or_corporate_name,
});

export default connect(mapStateToProps)(InvestorProfileStart);
